(function () {
  window.TitusObjectObserver.observe('_ALConfig', window, 50).then(() => {
    const config = window._ALConfig;
    const isLoyaltyRoute = typeof window.location?.pathname === 'string' && window.location.pathname.includes('/apps/loyalty');

    (Array.isArray(config?.pointEarnRules) ? config.pointEarnRules : []).forEach(rule => {
      rule.customerFacingIconUrl = 'https://cdn.shopify.com/s/files/1/0781/0000/5209/files/titus-cp-badge-2_430x.png';
    });

 
    if (window.TitusObserver && typeof window.TitusObserver.unsubscribe === 'function' && window._ALConfigUnsubscribe) {
      window.TitusObserver.unsubscribe(window._ALConfigUnsubscribe);
    }

    if (!isLoyaltyRoute && typeof window.initiateAppstleLoyaltyPage === 'function') {
      window.initiateAppstleLoyaltyPage();
    }
  }).catch(() => {
    console.error('Appstle Loyalty: Failed to load _ALConfig');
  });
})()


